import {ACTIVE_TAB, DEFAULT_SEARCH_STATE, SEARCH_SUCCESS} from "../constants";

function SearchReducer(state = DEFAULT_SEARCH_STATE, action) {

    switch (action.type) {

        case ACTIVE_TAB:
            let activeTab = action.payload

            return {
                ...state,
                activeTab: activeTab
            }

        case SEARCH_SUCCESS:

            const searchResultPayload = action.payload
            const {searchResults, includeAdverseMedia, additionalMediaLinks} = searchResultPayload

            return {
                ...state,
                activeTab: 0,
                searchResults: searchResults ? searchResults : [],
                includeAdverseMedia: includeAdverseMedia ? includeAdverseMedia : false,
                additionalMediaLinks: additionalMediaLinks ? additionalMediaLinks : []
            }

        default:
            return state;
    }
}

export default SearchReducer